import React from "react"
import SvgSpriteIcon from "shared/SvgSpriteIcon"

const SurveyRecipientsEmptyState = () => (
  <div className="flex flex-col w-full items-center pt-16">
    <SvgSpriteIcon iconName="surveys" className="w-16 h-16 mb-4" />
    <span>There are no survey recipients with the selected options.</span>
  </div>
)

export default SurveyRecipientsEmptyState
